import Axios from './http'
import BaseUrl from './ip-config'
import ConfigInfo from '../utils/config'
// import {Toast} from 'vant'
import {_getClearNullData} from '@/assets/js/other-methods'
import md5 from 'js-md5'

export function fetchData(bodyParams = {}, headParams = '', method = 'GET') {
    return new Promise((resolve) => {

        let data = _getClearNullData(bodyParams);
        // data['token'] = localStorage.getItem('yxcc_admin_token')
        data['timestamp'] = Math.floor(Date.now() / 1000)

        let phone = localStorage.getItem('qcw_phone');
        if (phone)
            data['phone'] = phone

        let str = '';
        Object.keys(data).sort().forEach(function(k){
            str += '&' + k + '=' + data[k];
        });

        str = (str.replace(/^&|&$/g, '') + ConfigInfo.salt);
        // console.log('before s:' + str);
        data['sign'] = md5(str).toUpperCase();

        let url = process.env.NODE_ENV === 'development' ? headParams : BaseUrl.basicApi + headParams
        let axios
        switch (method) {
            case 'get':
                axios = Axios.get(url, {params: data});
                break;
            case 'post':
                axios = Axios.post(url, data);
                break;
            case 'put':
                axios = Axios.put(url, data);
                break;
            case 'delete':
                axios = Axios.delete(url, {params: data});
                break;
            default:
                throw new Error('请输入正确的请求类型');
        }
        axios.then(res => {
            let result = res.data || {}
            if (!result) {
                resolve({result: 1, message: ConfigInfo.toastInfo.reqErrorMsg})

            }
            switch (+result.result) {
                case 0:
                    resolve(result)
                    break
                default:
                    resolve({result: 1, message: result.message || ConfigInfo.toastInfo.reqErrorMsg})
            }
        }, err => {
            console.log(err)
            resolve({result: 1, message: ConfigInfo.toastInfo.reqErrorMsg})
        }).catch(error => {
            console.log(error)
            resolve({result: 1, message: ConfigInfo.toastInfo.reqErrorMsg})

        })
    })
}
